<template>
<card>
    <h4 slot="header" class="card-title">User Profile</h4>
    <form>
        <div class="row">
            <div class="col-md-4">
                <base-input type="text" label="Name" :disabled="true" placeholder="Name" v-model="userProfile.name">
                </base-input>
            </div>
            <div class="col-md-4">
              <base-input type="email" label="Email" :disabled="true" placeholder="Email" v-model="userProfile.email">
              </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <base-input type="text" label="Team" :disabled="true" placeholder="Username" v-model="userProfile.team_name">
                </base-input>
            </div>
            <div class="col-md-4">
              <base-input type="text" label="Role" :disabled="true" placeholder="Username" v-model="userProfile.role">
              </base-input>
            </div>
        </div>
        <div class="clearfix"></div>
    </form>
</card>
</template>

<script>
import Card from 'src/components/Cards/Card.vue'
import axios from 'axios'

export default {
    components: {
        Card
    },
    props: ['user'],
    data() {
        return {
            accessToken: '',
            userProfile: [],
        }
    },
    async created() {
        this.accessToken = await this.$auth.getAccessToken()
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.userInfo = Object.assign({}, await this.$auth.getUser())
            axios
                .get('/user/profile/' + this.userInfo.email + '?access_token=' + this.accessToken)
                .then(response => (
                    this.userProfile = response.data[0]
                ));
        },
    }
}
</script>

<style>

</style>
